module.exports = __webpack_public_path__ + "static/media/credit_card_icon.fd84b22d.svg";